import url from './url';



export default url(({ id = ':id' }) => `/achievements/${id}/edit`);
